import type { FaireProductEntity } from "../../entity_types/product";

export const p_awaw5swqs2: FaireProductEntity = {
  token: "p_awaw5swqs2",
  type: "product",
  name: "Mezcal Jicara Tasting Glass",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/4403744225b3d6193b7b45fd5fe3893ddcc60bfbe63f1d2e5e5fc831e6c0723d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a88e979105b3a8db711990149f918c42be601621ca41dd366130b2ca3193ec8e.jpeg",
    "https://cdn.faire.com/fastly/ba793b9b17e7e3c9c14ace07a4a63b7bc02c9a783bec62e13b7a3915146ab1c3.jpeg",
    "https://cdn.faire.com/fastly/dd8c77a248cbc822345c0d2dc268dc4976ffd5d527ad1b3c93f88915b029209a.jpeg",
  ],
  priceDollars: 8,
  description:
    "The popular tasting glasses from our Infuse Gift Set are now available on their own! Traditionally, a mezcal tasting cup is a jicaras, or small cup made from the bark of the jicara fruit. The wide mouth of a jicara cup allows the alcohol to evaporate, leaving room for the full expression of the mezcal. We've worked with our artisan glass blowers out of Guadalajara to create a tasting glass shape that mimics that of a jicara cup. They are supposed to be a bit wobbly on the bottom and each shape is a bit different to mimic the variety of shapes a jicara cup can come in. \n\nSize: Appx. 3'' diameter x 1.5'' tall\nCapacity: Appx. 150ml\nPLEASE NOTE: each piece is handmade and will vary slightly in size, shape, and capacity. ",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:25.783Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
